import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import glamorousIcon from '../shared/icons'
import { AlertPopupSvg, SoldOutCouponSvg } from '../shared/icons/svg-images'
import { Message } from '@paypalcorp/worldready-react'

const Overlay = glamorous.div({
  position: 'fixed',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#000000',
  zIndex: '998',
  opacity: '0.45',
})

const PopupDiv = glamorous.div({
  position: 'fixed',
  top: '159px',
  margin: 0,
  height: '366px',
  width: '100%',
  zIndex: '999',
})

const PopupContainer = glamorous.div({
  maxWidth: '800px',
  margin: '0 auto',
  textAlign: 'center',
  backgroundImage: 'linear-gradient(287deg, #009cde, #003087)',
})

const AlertICON = glamorousIcon({
  '& svg': { height: '98', width: '98' },
})

AlertICON.defaultProps = { svg: AlertPopupSvg }

const IconContainer = glamorous.div({
  paddingTop: '47px',
  paddingBottom: '47px',
  width: '120px',
  margin: '0 auto',
})

const ContinueButton = glamorous.button('vx_btn', {
  width: '270px',
  height: '48px',
  background: 'white',
  marginTop: '48px',
  marginBottom: '36px',
  fontSize: '15px',
  fontWeight: '500',
  letterSpacing: 0,
  '@media only screen and (max-width: 768px)': {
    width: '271px',
  },
  ':hover': {
    background: 'white',
  },
})

const Content = glamorous.div({
  margin: '0 auto',
  textAlign: 'center',
  '@media only screen and (max-width: 768px)': {
    margin: '0 24px',
  },
})

const StyledMessage = glamorous.div({
  color: 'white',
  fontSize: '20px',
  fontWeight: '500',
  lineHeight: '0.9',
  letterSpacing: 0,
})

const Promotion = glamorous.div({
  paddingTop: '24px',
})

const OfferName = glamorous.div({
  fontSize: '15px',
  color: '#ffffff',
  textAlign: 'left',
})

const CouponICON = glamorousIcon({
  paddingTop: '6px',
  paddingRight: '12px',
  '& svg': { height: '24', width: '24' },
})

CouponICON.defaultProps = { svg: SoldOutCouponSvg }

const renderOffers = (offers) => {
  return offers.map((offer, idx) => {
    return (
      <Promotion id="sold-out-offer" key={idx}>
        <div
          style={{ display: 'flex', justifyContent: 'left', margin: '0 225px' }}
        >
          <CouponICON />
          <OfferName>{offer.name}</OfferName>
        </div>
      </Promotion>
    )
  })
}

const SoldOutOverlay = (props) => (
  <div>
    <Overlay />
    <PopupDiv>
      <PopupContainer>
        <IconContainer id="icon">
          <AlertICON />
        </IconContainer>
        <Content>
          <StyledMessage>
            <Message id="pages/product.product.soldOut" />
          </StyledMessage>
          {renderOffers(props.soldOutOffers)}
        </Content>
        <ContinueButton
          className="vx_btn vx_btn-secondary"
          onClick={() => props.history.push('/home')}
        >
          <Message id="pages/product.product.continueShopping" />
        </ContinueButton>
      </PopupContainer>
    </PopupDiv>
  </div>
)
SoldOutOverlay.propTypes = {
  history: PropTypes.object.isRequired,
  soldOutOffers: PropTypes.array.isRequired,
}

export default SoldOutOverlay
